import { PriceSummaryDiscountItem, RowProps } from '../types';
import { getDiscountBadge } from './getDiscountBadge';

export const getSavingsItemBadge = (item: PriceSummaryDiscountItem): RowProps['badge'] => {
  if (item.type === 'savings_plan') {
    const badgeType =
      item.planName === 'clever' ? 'Clever' : item.planName === 'premium' ? 'Premium' : 'Discount';

    return getDiscountBadge(item.percentage, badgeType);
  }

  return getDiscountBadge(item.percentage);
};
